import {
    CREATE_BROKER_USER_FAILURE,
    CREATE_BROKER_USER_REQUEST,
    CREATE_BROKER_USER_SUCCESS,
    FETCH_BROKER_USERS_FAILURE,
    FETCH_BROKER_USERS_REQUEST,
    FETCH_BROKER_USERS_SUCCESS,
    UPDATE_BROKER_USER_FAILURE,
    UPDATE_BROKER_USER_REQUEST,
    UPDATE_BROKER_USER_SUCCESS
} from '../../actions/broker/types';

/**
 *
 * @type BrokerUserState
 */
const initialState = {
    createBrokerUser: { loading: false, data: null, error: null },
    deleteBrokerUser: { loading: false, data: null, error: null },
    updateBrokerUser: { loading: false, data: null, error: null },
    brokerUserList: { loading: false, data: null, error: null }
};

/**
 *
 *
 *
 * @typedef {Object} ACTION
 * @property {string} type
 * @property {Array<*>} [payload]
 * @property {string} [error]
 *
 *
 *
 * @param { BrokerUserState} state
 * @param {ACTION} action
 *
 * @return {BrokerUserState}
 */
const BrokerUser = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_BROKER_USERS_REQUEST: {
            return {
                ...state,
                brokerUserList: { loading: true, data: null, error: null }
            };
        }
        case FETCH_BROKER_USERS_SUCCESS:
            return {
                ...state,
                brokerUserList: {
                    loading: false,
                    data: action.payload,
                    error: null
                }
            };
        case FETCH_BROKER_USERS_FAILURE:
            return {
                ...state,
                brokerUserList: {
                    loading: false,
                    data: null,
                    message: action.error
                }
            };
        case CREATE_BROKER_USER_REQUEST:
            return {
                ...state,
                createBrokerUser: { loading: true, data: null, error: null }
            };
        case CREATE_BROKER_USER_SUCCESS: {
            return {
                ...state,
                createBrokerUser: {
                    loading: false,
                    data: action.payload,
                    error: null
                },
                brokerUserList: addNewBrokerUserData(action.payload, {
                    ...state.brokerUserList
                })
            };
        }

        case CREATE_BROKER_USER_FAILURE:
            return {
                ...state,
                createBrokerUser: {
                    loading: false,
                    error: action.payload ||"Error",
                    data: null
                }
            };

        case UPDATE_BROKER_USER_REQUEST:
            return {
                ...state,
                updateBrokerUser: { loading: true, error: null, data: null }
            };
        case UPDATE_BROKER_USER_FAILURE:
            return {
                ...state,
                updateBrokerUser: {
                    loading: false,
                    error: action.error ||"Error",
                    data: null
                }
            };
        case UPDATE_BROKER_USER_SUCCESS:
            return {
                ...state,
                updateBrokerUser: {
                    loading: false,
                    error: null,
                    data: action.payload
                },
                brokerUserList: updateBrokerUserListState(action.payload, {
                    ...state.brokerUserList
                })
            };

        default:
            return state;
    }
};

/**
 *
 * @param {BrokerUser} dataToUpdate
 * @param {BrokerUserListState} state
 * @returns {BrokerUserListState}
 */
function addNewBrokerUserData(dataToUpdate, state) {
    state.data.data = [ dataToUpdate,...state.data.data];
    state.data.total++;
    return state;
}

/**
 *
 * @param {BrokerUser} dataToUpdate
 * @param {BrokerUserListState} state
 * @returns {BrokerUserListState}
 */
function updateBrokerUserListState(dataToUpdate, state) {
    state.data.data = state.data.data.map((obj) => {
        if (obj._id !== dataToUpdate._id) return obj;
        return { ...dataToUpdate };
    });
    return state;
}

export default BrokerUser;
